import { CanvasEdge, CanvasNode } from '../../tabs/CampaignWorkflowTab/components/Canvas/Canvas';
import { CanvasState } from '../../tabs/CampaignWorkflowTab/components/Canvas/state/CanvasState';
import { Canvas } from '../../domain/Canvas/Canvas';

export class NewCampaignResponseToCanvasStateAdapter implements CanvasState {
  public constructor() {
    const canvas = Canvas.createForNewCampaign();

    const { nodes, edges, showIntroVariant } = canvas.convertToState();

    this.nodes = nodes;
    this.edges = edges;
    this.showIntroVariant = showIntroVariant;
  }

  public showIntroVariant: boolean;
  public nodes: CanvasNode[];
  public edges: CanvasEdge[];
}
